import { render } from "./edit.vue?vue&type=template&id=586c1c44"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=586c1c44&lang=scss"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/widget/article/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "586c1c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('586c1c44', __exports__)) {
    console.log('reload')
    api.reload('586c1c44', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=586c1c44", () => {
    console.log('re-render')
    api.rerender('586c1c44', render)
  })

}


export default __exports__